export default __webpack_public_path__ + "static/media/sign in farmer2.fc68ea16.png";